import React, { useEffect, useRef } from 'react';
function useScrollReveal(delay = 0) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.opacity = '0';
    el.style.transform = 'translateY(40px)';
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          el.style.transition = 'opacity 0.8s ease, transform 0.8s ease';
          el.style.opacity = '1';
          el.style.transform = 'translateY(0)';
        }, delay);
        observer.disconnect();
      }
    }, {
      threshold: 0.1
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [delay]);
  return ref;
}
export function SocialProof() {
  const headerRef = useScrollReveal(0);
  const quoteRef = useScrollReveal(150);
  const reasonsRef = useScrollReveal(300);
  return <section className="w-full py-20 sm:py-28 relative overflow-hidden" style={{
    backgroundColor: '#0a0a0a'
  }} aria-label="Why Hialeah men keep coming back" data-id="element-526">
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse at 50% 0%, rgba(201,168,76,0.05) 0%, transparent 60%)'
    }} aria-hidden="true" data-id="element-527" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-528">
        <div ref={headerRef} className="text-center mb-14" data-id="element-529">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-530">
            <div style={{
            width: '40px',
            height: '1px',
            background: '#C9A84C'
          }} data-id="element-531" />
            <span className="section-label" data-id="element-532">Social Proof</span>
            <div style={{
            width: '40px',
            height: '1px',
            background: '#C9A84C'
          }} data-id="element-533" />
          </div>
          <h2 style={{
          fontFamily: 'var(--font-heading)',
          fontSize: 'clamp(1.8rem, 4vw, 2.8rem)',
          fontWeight: 700,
          color: '#F5F5F5',
          lineHeight: 1.2
        }} data-id="element-534">
            Why Hialeah Men{' '}
            <span style={{
            color: '#C9A84C',
            fontStyle: 'italic'
          }} data-id="element-535">
              Keep Coming Back
            </span>
          </h2>
        </div>

        {/* Testimonial */}
        <div ref={quoteRef} data-id="element-536">
          <div className="relative p-8 sm:p-10 rounded-sm mb-14" style={{
          backgroundColor: '#111111',
          border: '1px solid rgba(201,168,76,0.25)'
        }} data-id="element-537">
            {/* Quote mark */}
            <div className="absolute top-6 left-8" style={{
            fontFamily: 'var(--font-heading)',
            fontSize: '5rem',
            color: 'rgba(201,168,76,0.15)',
            lineHeight: 1,
            userSelect: 'none'
          }} aria-hidden="true" data-id="element-538">
              "
            </div>

            <blockquote className="relative z-10 pt-6" data-id="element-539">
              <p style={{
              fontFamily: 'var(--font-heading)',
              fontSize: 'clamp(1.1rem, 2.5vw, 1.4rem)',
              fontStyle: 'italic',
              color: '#F5F5F5',
              lineHeight: 1.7,
              marginBottom: '1.5rem'
            }} data-id="element-540">
                "I've been to six different shops in Hialeah in two years. This
                is the only one where I walk out looking exactly how I pictured
                it."
              </p>
              <footer className="flex items-center gap-3" data-id="element-541">
                <div style={{
                width: '30px',
                height: '1px',
                background: '#C9A84C'
              }} data-id="element-542" />
                <div data-id="element-543">
                  <div className="flex gap-1 mb-1" aria-label="5 stars" data-id="element-544">
                    {[1, 2, 3, 4, 5].map(i => <svg key={i} width="14" height="14" viewBox="0 0 24 24" fill="#C9A84C" stroke="none" aria-hidden="true" data-id="element-545">
                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" data-id="element-546" />
                      </svg>)}
                  </div>
                  <span style={{
                  fontFamily: 'var(--font-body)',
                  fontSize: '0.85rem',
                  color: '#888'
                }} data-id="element-547">
                    Hialeah Customer
                  </span>
                </div>
              </footer>
            </blockquote>
          </div>
        </div>

        {/* Why they keep coming back */}
        <div ref={reasonsRef} data-id="element-548">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6" data-id="element-549">
            <ReasonCard icon={<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-551">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-552" />
                </svg>} title="The Results" description="Men come to By Guerra once out of curiosity. They come back because of the results." data-id="element-550" />
            <ReasonCard icon={<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-554">
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" data-id="element-555" />
                </svg>} title="The Respect" description="The way they're greeted when they walk in. The way their barber actually listens." data-id="element-553" />
            <ReasonCard icon={<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#C9A84C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-557">
                  <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" data-id="element-558" />
                  <polyline points="17 6 23 6 23 12" data-id="element-559" />
                </svg>} title="The Consistency" description="They never leave second-guessing themselves. That's not an accident. That's the standard." data-id="element-556" />
          </div>
        </div>
      </div>
    </section>;
}
function ReasonCard({
  icon,
  title,
  description
}: {
  icon: React.ReactNode;
  title: string;
  description: string;
}) {
  return <div className="p-6 rounded-sm flex flex-col gap-4" style={{
    backgroundColor: '#111111',
    border: '1px solid rgba(201,168,76,0.15)'
  }} data-id="element-560">
      <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{
      backgroundColor: 'rgba(201,168,76,0.1)',
      border: '1px solid rgba(201,168,76,0.25)'
    }} data-id="element-561">
        {icon}
      </div>
      <h3 style={{
      fontFamily: 'var(--font-callout)',
      fontSize: '1.1rem',
      fontWeight: 600,
      color: '#F5F5F5',
      letterSpacing: '0.04em'
    }} data-id="element-562">
        {title}
      </h3>
      <p style={{
      fontFamily: 'var(--font-body)',
      fontSize: '0.95rem',
      color: '#888',
      lineHeight: 1.7
    }} data-id="element-563">
        {description}
      </p>
    </div>;
}